export default __webpack_public_path__ + "static/media/MishHeroMob.06d44e2b.png";